(() => {
  const motion = matchMedia('(hover: hover) and (pointer: fine) and (prefers-reduced-motion: no-preference)');
  const animations = new Map();
  const frame = (size, position, offset, easing) => ({
    backgroundSize: `${size}% .0625rem`, backgroundPosition: `${position}% 100%`, offset, easing
  });

  function change(event, entering) {
    const link = event.target.closest?.('.cl-link');
    if (!link || (event.relatedTarget instanceof Node && link.contains(event.relatedTarget))) return;
    if (!motion.matches) return;
    const style = getComputedStyle(link);
    const current = { backgroundSize: style.backgroundSize, backgroundPosition: style.backgroundPosition };
    const token = style.getPropertyValue('--cl-motion-base').trim();
    const duration = parseFloat(token) * (token.endsWith('ms') ? 1 : 1000) || 300;
    const easing = style.getPropertyValue('--cl-motion-ease').trim() || 'ease';
    animations.get(link)?.cancel();
    const frames = entering ? [
      frame(0, 0, 0, easing),
      frame(100, 0, 0.33, 'linear'),
      frame(100, 100, 0.3301, easing),
      frame(0, 100, 0.66, 'linear'),
      frame(0, 0, 0.6601, easing),
      frame(100, 0, 1, 'linear')
    ] : [
      current,
      { backgroundSize: '0% .0625rem', backgroundPosition: current.backgroundPosition }
    ];
    const animation = link.animate(frames, {
      duration: duration * (entering ? 3 : 1),
      easing: entering ? 'linear' : easing,
      fill: 'forwards'
    });
    animations.set(link, animation);
    if (!entering) animation.onfinish = () => {
      if (!link.matches('[aria-current="page"], .is-active, .cl-link--inline')) {
        animation.cancel();
        if (animations.get(link) === animation) animations.delete(link);
      }
    };
  }
  document.addEventListener('pointerover', event => change(event, true));
  document.addEventListener('pointerout', event => change(event, false));
  motion.addEventListener('change', () => {
    animations.forEach(animation => animation.cancel());
    animations.clear();
  });
})();
